// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.xcapit",
    name: "Xcapit",
    homepage: "https://xcapit.com/",
    image_id: "17f59b75-21b0-4b3f-b024-fe4b9b8d2300",
    app: {
        browser: "https://app.xcapit.com/",
        ios: "https://apps.apple.com/ar/app/xcapit/id1545648148",
        android: "https://play.google.com/store/apps/details?id=com.xcapit.app",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: null,
        universal: "https://app.xcapit.com/links",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map